import { createGlobalState, useSessionStorage } from "@vueuse/core";

const useState = createGlobalState(() =>
  useSessionStorage("vue-local-storage", {
    token: "",
    liffId: "",
    isLoading: false,
    userId: "",
    isAdmin: false,
  })
);

export default useState;
